import * as THREE from 'three'
import { OrbitControls } from 'three/addons/controls/OrbitControls.js'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js'
import * as dat from 'lil-gui'
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js'
import { OutlinePass } from 'three/addons/postprocessing/OutlinePass.js'

//Canvas
const canvas = document.querySelector('canvas.webgl')

/**
 * Cursor
 */

const cursor = {
    x:0,
    y:0
}

window.addEventListener('mousemove', (event) =>
{
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = -(event.clientY / sizes.height -0.5)

    mouse.x = (event.clientX / sizes.width) * 2 - 1;
    mouse.y = -(event.clientY / sizes.height) * 2 + 1;
})

//Cursor grabbing
canvas.addEventListener('mousedown', () => {
    canvas.style.cursor = 'grab';
  });
  
  canvas.addEventListener('mouseup', () => {
    canvas.style.cursor = 'grab';
  });
  
  canvas.addEventListener('mousemove', (e) => {
    if (e.buttons === 1) {
      canvas.style.cursor = 'grabbing';
    }
  });
  

/**
 * Base
 */

//Debug UI
// const gui = new dat.GUI()
// const parameters = {
//     color: 0xff0000
// }

// Scene
const scene = new THREE.Scene()
const cubeTextureLoader = new THREE.CubeTextureLoader()
cubeTextureLoader.setPath('textures/cubeMaps/')
const backgroundTexture = cubeTextureLoader.load([
    'px.png',
    'nx.png',
    'py.png',
    'ny.png',
    'pz.png',
    'nz.png'
])
backgroundTexture.colorSpace = THREE.SRGBColorSpace
scene.background = backgroundTexture
    
/**
 * Models
 *  */

// Cinema
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('/draco/')

const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

let interactiveBillboardGroup = null;
let clickableMeshes = [];

gltfLoader.load(
    './models/cinema.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) => {
            if (child.isMesh && child.material) {
                // Handle single material
                if (child.material.isMaterial) {
                    if (child.material.map) {
                        child.material.map.colorSpace = THREE.SRGBColorSpace;
                    }
                    if (child.material.emissiveMap) {
                        child.material.emissiveMap.colorSpace = THREE.SRGBColorSpace;
                    }
                    // Ensure the material's color itself is in sRGB if it's not a texture
                    if (child.material.color) {
                        child.material.color.set(child.material.color.getHex()); // Re-set to apply color space
                    }
                    child.material.needsUpdate = true;
                }
                // Handle array of materials (e.g., MultiMaterial)
                else if (Array.isArray(child.material)) {
                    child.material.forEach(material => {
                        if (material.map) {
                            material.map.colorSpace = THREE.SRGBColorSpace;
                        }
                        if (material.emissiveMap) {
                            material.emissiveMap.colorSpace = THREE.SRGBColorSpace;
                        }
                        // Ensure the material's color itself is in sRGB if it's not a texture
                        if (material.color) {
                            material.color.set(material.color.getHex()); // Re-set to apply color space
                        }
                        material.needsUpdate = true;
                    });
                }
            }
        });
        scene.add(gltf.scene)

        interactiveBillboardGroup = gltf.scene.getObjectByName('Interactive_Billboard');
        if (interactiveBillboardGroup) {
            interactiveBillboardGroup.traverse((child) => {
                if (child.isMesh) {
                    clickableMeshes.push(child);
                }
            });
        }

        const signboardNames = ['Board_-_Movies', 'Board_-_About', 'Board_-_Projects', 'Board_-_Contact'];
        signboardNames.forEach(name => {
            const signboard = gltf.scene.getObjectByName(name);
            if (signboard && signboard.isMesh) {
                clickableMeshes.push(signboard);
            }
        });

        // Add a mousedown event listener to the canvas
        renderer.domElement.addEventListener('mousedown', (event) => {

        // Calculate normalized device coordinates (NDC) of mouse position
        const mouse = new THREE.Vector2();
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        // Create a raycaster from the camera and mouse position
        const raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, camera);

        // Check for intersections between the raycaster and the billboard mesh
        const intersects = raycaster.intersectObjects(clickableMeshes);

        // If a clickable mesh is clicked, log a message in the console
        if (intersects.length > 0) {
        console.log('Clickable object clicked!', intersects[0].object.name);
        }
        });
    })


// Object
const geometry = new THREE.BoxGeometry(1, 1, 1)
const material = new THREE.MeshBasicMaterial({ color: 0xff0000 })
const mesh = new THREE.Mesh(geometry, material)
// scene.add(mesh)

//Floor
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry (10,10),
    new THREE.MeshStandardMaterial({
        color: '#444444',
        metalness: 0,
        roughness: 0.5
    })
)
floor.receiveShadow = true
floor.rotation.x = - Math.PI * 0.5
floor.position.y = -1
// scene.add(floor)


/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 2.0)
scene.add(ambientLight)



/**  
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    //Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    //Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    //Update renderer
    renderer.setSize(sizes.width, sizes.height)

})

// Debug
// gui 
//     .addColor(parameters, 'color')
//     .onChange(()=>
//     {
        //        material.color.set(parameters.color)
//     })

// gui
//     .add(mesh.position, 'y')

// gui
//     .add(mesh, 'visible')

// gui.add(floor, 'visible')

window.addEventListener('dblclick', () =>
{
    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement

    if(!fullscreenElement)
    {
        if(canvas.requestFullscreen)
        {
            canvas.requestFullscreen()
        }
        else if(canvas.webkitRequestFullscreen)
        {
            canvas.webkitRequestFullscreen()
        }
    }
    else
    {
        if(document.exitFullscreen)
        {
            document.exitFullscreen()
        }
        else if(document.webkitExitFullscreen)
        {
            document.webkitExitFullscreen()
        }
    }
})


// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.z = 3
scene.add(camera)

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    outputColorSpace: THREE.SRGBColorSpace
})
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.25;
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

//Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.enablePan = false

//Orbit & Zoom limits
controls.minPolarAngle = 1;
controls.maxPolarAngle =  Math.PI * 0.5
controls.minAzimuthAngle = 0
controls.maxAzimuthAngle = Math.PI * 0.5
controls.minDistance = 15
controls.maxDistance = 21

// Post-processing
const composer = new EffectComposer(renderer);
const renderPass = new RenderPass(scene, camera);
composer.addPass(renderPass);

const outlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), scene, camera);
outlinePass.edgeStrength = 3;
outlinePass.edgeGlow = 1;
outlinePass.edgeThickness = 1;
outlinePass.pulsePeriod = 0; // No pulsing
outlinePass.visibleEdgeColor.set('#ffffff'); // White glow
outlinePass.hiddenEdgeColor.set('#190a05'); // Darker color for hidden edges
composer.addPass(outlinePass);

// Raycaster for hover detection
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

//Animate
const clock = new THREE.Clock()

const tick = () =>
{
    window.requestAnimationFrame(tick)

    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Hover detection
    let hoveredObject = null;
    raycaster.setFromCamera(mouse, camera);

    const intersects = raycaster.intersectObjects(clickableMeshes);

    if (intersects.length > 0) {
        const intersectedMesh = intersects[0].object;
        // If the intersected mesh is a child of the interactiveBillboardGroup, select the group
        if (interactiveBillboardGroup && interactiveBillboardGroup.children.includes(intersectedMesh)) {
            hoveredObject = interactiveBillboardGroup;
        } else {
            hoveredObject = intersectedMesh;
        }
    }

    if (hoveredObject) {
        outlinePass.selectedObjects = [hoveredObject];
        canvas.style.cursor = 'pointer';
    } else {
        outlinePass.selectedObjects = [];
        canvas.style.cursor = 'grab';
    }

    // Render
    composer.render()
}

tick()